module.exports = __webpack_public_path__ + "static/media/dts.b17be645.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dts.png
// module id = 119
// module chunks = 0